import vue from 'vue'
// import NP from 'number-precision'
// import AddOrder from '../components/orderAdd.vue'
import DeleteOrder from '../components/orderDelete.vue'
import DeleteOrderAll from '../components/orderDeleteAll.vue'
// import { isNull, isNumber } from '../../assets/js/validators'
import store from '../../store/index'
import ViewModel from '../components/viewPage.vue'
// import Bus from '../../assets/js/eventBus'
import orderViewUser from '../components/orderViewUser.vue'
// import orderViewClient from '../components/orderViewClient.vue'
// import orderStatus from './../components/orderStatus.vue'
// import modelSearch from './../components/modelSearch.vue'
// import financeVerify from './../components/financeVerify.vue'

const that = vue.prototype
export default {
  className: 'verifyOrder', // 待审核订单
  mixin: {
    selection: true,
    actionWidth: 120,
    fields: [
      { // 销售信息
        name: 'userid',
        note: '销售人员',
        width: 100,
        view: {
          component: orderViewUser
        }
      },
      // 用户所属公司
      {
        name: 'userCompany',
        width: 80,
        note: '所属公司',
        // validators: [
        //   val => (val) ? null : '所属公司不可为空'
        // ],
      },
      { // 型号
        name: 'finishProductid',
        // listWhere: (where) => {
        //   where.isBatching = { $ne: true }
        //   where.formula = { $exists: true }
        // },
        width: 80,
        // validators: [
        //   isNull
        // ]
      },
      {
        // 所属车间型号
        name: 'modelId',
        width: 80,
        note: '车间型号',
        render: (record) => {
          return `${record.finishProductid.model.name}`
        },
      },
      {// 包装
        name: 'packid',
        note: '包装',
        width: 80,
      },
      {// 托盘
        name: 'palletid',
        width: 80,
      },
      {
        name: 'status',
        width: 80,
      },
      {// 麦头
        name: 'markid',
        width: 80,
      },
      { // 客户
        name: 'clientid',
        width: 110,
        // view: {
        //   component: orderViewClient
        // },
        // hidden: () => store.state.user && store.state.user.adminRole === 'workshop',
        // listWhere: (where) => {
        //   // if (store.state.user.adminRole === 'sale') {
        //   // where.userid = store.state.user.objectId
        //   // }
        //   if (store.state.user && store.state.user.allClient === 'Yes') { } else {
        //     where.userid = store.state.user.objectId
        //   }
        // },
        // validators: [
        //   isNull
        // ]
      },
      { // 吨数
        name: 'amount',
        // hidden: () => true,
        width: 80,
        // validators: [
        //   isNull, isNumber
        // ]
      },
      { // 运费
        name: 'shipping',
        width: 80,
        disabled: true,
        // hidden: () => store.state.user && store.state.user.adminRole === 'workshop',
        // validators: [
        //   isNull, isNumber
        // ]
      },
      {
        name: 'pricePerTon',
        note: '每吨运费',
        width: 120,
        // validators: [
        //   isNull, isNumber
        // ]
      },
      { // 售价
        name: 'sellingPrice',
        width: 100,
        // disabled: true,
        // hidden: () => store.state.user && store.state.user.adminRole === 'workshop',
        // validators: [
        //   isNull, isNumber
        // ]
      },
      { // 成本
        name: 'costPrice',
        width: 80,
        // hidden: () => store.state.user && store.state.user.adminRole === 'workshop',
        // disabled: true,
        // validators: [
        //   isNull, isNumber
        // ]
        render: (record) => {
          // if (store.state.user && store.state.user.allClient === 'No' && Object.keys(store.state.user).indexOf('correlatedBy') !== -1 && store.state.user.correlatedBy.length === 0) { return `` } else if (store.state.user && store.state.user.allClient === 'No' && Object.keys(store.state.user).indexOf('correlatedBy') === -1) { return `` } else { return `${record.costPrice}` }
          if (store.state.user && Object.keys(store.state.user).indexOf('correlatedUser') !== -1 && store.state.user.correlatedUser.length) { return `` } else { return `${record.costPrice}` }
        },
      },

      // 每吨运费

      { // 利润
        name: 'profit',
        width: 80,
        disabled: true,
        // hidden: () => true
        // hidden: () => store.state.user && store.state.user.adminRole === 'workshop',
        // validators: [
        //   isNull, isNumber
        // ]
      },

      { // 提成
        name: 'commission',
        width: 80,
        hidden: () => true
        // hidden: () => store.state.user && store.state.user.adminRole === 'workshop',
        // validators: [
        //   isNull, isNumber
        // ]
      },
      // 客户提成
      {
        name: 'clientCommission',
        width: 100,
        disabled: true,
        // validators: [
        //   isNull, isNumber
        // ]
      },

      {
        name: 'taxRate',
        width: 80,
      },
      { // 交付日期
        name: 'shipDate',
        // validators: [
        //   isNull,
        //   (val) => new Date(val).getTime() + 24 * 60 * 60 * 1000 - 1 >= new Date().getTime() ? null : '不可选择今日之前的日期'
        // ]
      },
      // 发出时间
      {
        name: 'remarks',
        width: 80,
      },
      {
        name: 'createdAt',
        note: '下单日期'
      },
      // 更新时间
      'updatedAt',
    ],
  },
  search: [

    'userCompany',
    'clientid',
    'updatedAt',
    'sentAt'
  ],
  hooks: {
    async beforeFetch ({ where }) {
      if (store.state.user.correlatedBy && store.state.user.correlatedBy.length !== 0) {
        where.$or = [
          {
            userid: {
              $in: store.state.user.correlatedBy
            }
          },
          {
            userid: store.state.user.objectId
          },

        ]
      } else {
        where.userid = store.state.user.objectId
      }
      // if (store.state.user.correlatedBy && store.state.user.correlatedBy.length !== 0) {
      //   where.userid = {
      //     $in: store.state.user.correlatedBy
      //   }
      //   where.status = 'financeVerify'
      //   // where.shopManagementid = {
      //   //   $in: store.state.user.shopManagements
      //   // }
      // } else {
      //   where.status = '1546513'
      // }

      // if (store.state.user && store.state.user.adminRole === 'sale') {
      //   // 销售经理
      //   where.userid = store.state.user.objectId
      // }
      // if (store.state.user && store.state.user.adminRole === 'admin') {
      //   // 超级管理员
      // }
      // if (store.state.user && store.state.user.adminRole === 'workshop') {
      //   // 车间经理
      // where.shopManagementid = {
      //   $in: store.state.user.shopManagements
      // }
      // }
    }
  },
  action: {
    view: store.state.user && store.state.user.authority.financeVerifyOrder.view ? {
      type: 'row',
      text: '查看',
      viewTitle: '查看订单',
      component: ViewModel
    } : false,
    create: false,

    choiceDel: store.state.user && store.state.user.authority.financeVerifyOrder.del
      ? {
        type: 'list',
        text: '批量删除',
        buttonType: 'danger', // 按钮的类型
        component: DeleteOrderAll
      } : false,

    verify: store.state.user && store.state.user.authority.financeVerifyOrder.verify
      ? {
        type: 'row',
        text: '审核',
        callback: async ({ record, vm, modelName }) => {
          await vm.confirm('提示', '确认审核此订单？')
          let rs = null
          let res = null
          let data = {
            amount: record.amount,
            clientCommission: record.clientCommission,
            clientid: record.clientid.objectId,
            commission: record.commission,
            costPrice: record.costPrice,
            finishProductid: record.finishProductid.objectId,
            markid: record.markid ? record.markid.objectId : '',
            orderDate: record.orderDate,
            packid: record.packid.objectId,
            palletid: record.palletid.objectId,
            pricePerTon: record.pricePerTon,
            profit: record.profit,
            remarks: record.remarks,
            sellingPrice: record.sellingPrice,
            shipDate: record.shipDate,
            shipping: record.shipping,
            shopManagementid: record.shopManagementid.objectId,
            status: 'add',
            taxRate: record.taxRate,
            userCompany: record.userCompany.objectId,
            userid: record.userid.objectId,
            sentAt: record.sentAt,
            verifyStatus: record.verifyStatus,
            modelId: record.modelId.objectId
          }
          try {
            rs = await that.$modelAjax.post('Order', data)
            res = await that.$modelAjax.delete(modelName, record.objectId)
          } catch (e) {
            vm.$notification.error({
              message: '网络错误',
              description: '网络错误'
            })
          }
          if (rs && res) {
            vm.$notification['success']({
              message: '操作成功',
              description: '订单已审核'
            })
            vm.refresh()
          }
        },
        // component: financeVerify,
        hidden (record) {
          if (record.record) {
            return (record.record.userid.objectId === store.state.user.objectId && store.state.user.correlatedBy.indexOf(store.state.user.objectId) === -1)
          } else {
            return false
          }
        }
      } : false,
    myDelete: store.state.user && store.state.user.authority.financeVerifyOrder.del
      ? {
        type: 'row',
        text: '删除',
        component: DeleteOrder,
        // hidden (record) {
        //   if (record.record) {
        //     return (record.record.userid.objectId === store.state.user.objectId && store.state.user.correlatedBy.indexOf(store.state.user.objectId) === -1)
        //   } else {
        //     return false
        //   }
        // }
      }
      : false
    // deleteAll: store.state.user && store.state.user.adminRole === 'admin'
    //   ? {
    //     type: 'list',
    //     text: '删除',
    //     component: DeleteOrder
    //   }
    //   : false
  }
}
